(function () {
    'use strict';

    angular.module('eDocumentsApp').factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal($q, Account) {
        var _identity,
            _pendingIdentity,
            _authenticated = false;

        // SUP-12293: an account with the Digital Archive role and none of these sees the Digital Archive only (the
        // server confines it the same way: ArchiveOnlyAccount.FULL_ACCESS_ROLES).
        var FULL_ACCESS_ROLES = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SUPERADMIN', 'ROLE_PARTNER', 'ROLE_INTEGRATION'];

        return {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isUserEntityManager: isUserEntityManager,
            isUserEntityMember: isUserEntityMember,
            isIdentityResolved: isIdentityResolved,
            isArchiveOnly: isArchiveOnly,
            hasNoAccess: hasNoAccess,
            homeState: homeState,
        };

        function isArchiveOnly() {
            return hasAnyAuthority(['ROLE_DIGITAL_ARCHIVE']) && !hasAnyAuthority(FULL_ACCESS_ROLES);
        }

        /**
         * A signed-in account left with no role that opens any area (the server allows it its own account only).
         * False while the identity is being (re)loaded: identity(true) clears it but leaves _authenticated set, and
         * reading "no roles yet" as "no access" sent every user to the access-denied page right after signing in.
         */
        function hasNoAccess() {
            return _authenticated && !!_identity && !hasAnyAuthority(FULL_ACCESS_ROLES.concat(['ROLE_DIGITAL_ARCHIVE']));
        }

        /**
         * The state a signed-in user starts on: the Documents list, the Digital Archive for an archive-only account, or
         * the access-denied page for an account with no role left.
         */
        function homeState() {
            if (hasNoAccess()) {
                return 'accessdenied';
            }
            return isArchiveOnly() ? 'digital-archive-document' : 'document';
        }

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        /** Whether the account belongs to the entity, as its manager or not. */
        function isUserEntityMember(communicationEntityId) {
            if (!_authenticated || !_identity || !_identity.userEntities) {
                return false;
            }
            for (var i = 0; i < _identity.userEntities.length; i++) {
                if (_identity.userEntities[i].entityId === communicationEntityId) {
                    return true;
                }
            }
            return false;
        }

        function isUserEntityManager(communicationEntityId) {
            if (!_authenticated || !_identity || !_identity.userEntities) {
                return false;
            }

            if (_identity.userEntities && _identity.userEntities.length > 0) {
                for (var i = 0; i < _identity.userEntities.length; i++) {
                    if (_identity.userEntities[i].entityId === communicationEntityId) {
                        return _identity.userEntities[i].manager;
                    }
                }
            }

            return false;
        }

        function hasAnyAuthority(authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(
        function (_id) {
            return _id.authorities && _id.authorities.indexOf(authority) !== -1;
        },
        function () {
            return false;
        }
      );
        }

        function identity(force) {
            if (force === true) {
                _identity = undefined;
                _pendingIdentity = undefined;
            }

      // EDOCS-652: a page load asks for the identity from several places at once (the router's authorisation,
      // the navbar); share the request in flight instead of sending GET /api/account once per caller.
            if (angular.isUndefined(_identity) && _pendingIdentity) {
                return _pendingIdentity;
            }

            var deferred = $q.defer();

      // check and see if we have retrieved the identity data from the server.
      // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

      // retrieve the identity data from the server, update the identity object, and then resolve.
            _pendingIdentity = deferred.promise;
            Account.get().$promise.then(getAccountThen).catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;
                if (_pendingIdentity === deferred.promise) {
                    _pendingIdentity = undefined;
                }
                deferred.resolve(_identity);
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                if (_pendingIdentity === deferred.promise) {
                    _pendingIdentity = undefined;
                }
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }
    }
})();
